import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import HomeMelbourne from "./pages/HomeMelbourne";
import HomeMorningtonPeninsula from "./pages/HomeMorningtonPeninsula";
import HomeGreatOceanRd from "./pages/HomeGreatOceanRd";
import HomeCountryVictoria from "./pages/HomeCountryVictoria";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />   {/* 👈 This is where it belongs */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/HomeMelbourne" element={<HomeMelbourne />} />
        <Route path="/HomeMorningtonPeninsula" element={<HomeMorningtonPeninsula />} />
        <Route path="/HomeGreatOceanRd" element={<HomeGreatOceanRd />} />
        <Route path="/HomeCountryVictoria" element={<HomeCountryVictoria />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

